import { clientApi } from "@/utils/api";

import { TGetMeResDto } from "@/api/services/admin/auth/dtos/get-me.dto";
import { TLogoutReqDto, TLogoutResDto } from "@/api/services/admin/auth/dtos/logout.dto";
import { TRefreshTokenReqDto, TRefreshTokenResDto } from "@/api/services/admin/auth/dtos/refresh-token.dto";
import { TVerifyOAuthTokenDto, TVerifyOAuthTokenReqDto, TVerifyOAuthTokenResDto } from "@/api/services/admin/auth/dtos/verify-oauth-token.dto";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { setToken } from "@/utils/token";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

export const fetchMeApi = async (): Promise<TGetMeResDto> => {
  const { data } = await clientApi.get<TGetMeResDto>("/get-me");
  return data;
};

export const useMe = (options?: Omit<UseQueryOptions<TGetMeResDto>, "queryKey" | "queryFn">) => {
  return useQuery({
    queryKey: [QUERY_KEYS.USER.FETCH_ME],
    queryFn: fetchMeApi,
    ...options,
  });
};

export const refreshTokenApi = async (payload: TRefreshTokenReqDto): Promise<TRefreshTokenResDto> => {
  const rs = await clientApi.post<TRefreshTokenResDto>("/refresh-token", payload);
  const { data } = rs.data;
  setToken(data.accessToken, data.refreshToken);
  return rs.data;
};

export const logoutApi = async (payload?: TLogoutReqDto): Promise<TLogoutResDto> => {
  const rs = await clientApi.post<TLogoutResDto>("/logout", payload);
  return rs?.data;
};

/**
 * Trades the single-use hand-off token minted by the Center for a Match session.
 * The token is consumed server-side, so it may only be posted once.
 */
export const verifyOAuthTokenApi = async (token: string): Promise<TVerifyOAuthTokenDto> => {
  const payload: TVerifyOAuthTokenReqDto = { token };
  const {
    data: { data },
  } = await clientApi.post<TVerifyOAuthTokenResDto>("/oauth/verify-token", payload);
  return data;
};
